import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import store from "./redux/store";

import App from './components/App';

//Development-only. Axios helpers
import axios from 'axios';
window.axios = axios;

const container = document.querySelector('#root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </Provider>
);
